import React from 'react';
import ReactDOM from 'react-dom';

import * as S from './styles';

type Props = {
  active: boolean;
};

const Overlay = (props: Props): JSX.Element | null => {
  if (!IS_BROWSER) {
    return null;
  }

  const rootEl = document.getElementById('root-overlay');

  if (!rootEl) {
    return null;
  }

  return ReactDOM.createPortal(<S.Overlay visible={props.active} />, rootEl);
};

Overlay.defaultProps = {
  active: false,
};

export default Overlay;
